import { FC } from 'react';
import InnerWrapper from './InnerWrapper';

const ClientsReportActiveUsers: FC<any> = ({ children }) => <InnerWrapper>{children}</InnerWrapper>;

export default ClientsReportActiveUsers;
